import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { LayoutService } from '@app/core/services/layout.service';
import { RememberService } from '@app/core/services/remember.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { DocArticleGet, DocArticleService } from '@app/services/doc-article.service';

@Component({
    selector: 'tt-doc-articles',
    templateUrl: './doc-articles.component.html',
    styleUrls: ['./doc-articles.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush, // the new kendo editor is slow, so can't use default change detection
})
export class DocArticlesComponent extends ComponentBaseComponent implements OnInit, OnDestroy {
    public get?: DocArticleGet;

    public docArticlesTree?: Item[];

    public rootDocArticles: Item[] = [];

    public filter = '';

    public selectedDocArticleKeyno = '';

    public tablet: MediaQueryList;

    constructor(layout: LayoutService, translate: TranslateService, private state: StateService, private remember: RememberService, private docarticle: DocArticleService, public cdr: ChangeDetectorRef) {
        super();
        translate.translated$.subscribe({ next: () => setTimeout(() => cdr.markForCheck(), 50) });
        this.tablet = layout.getMediaQueries().tablet;
    }

    public async onSubmit(event: { back: number; docarticle_keyno: string }) {
        await this.loadList();

        if (event.back === 2) {
            this.selectedDocArticleKeyno = '';
        } else if (event.docarticle_keyno > '' && event.docarticle_keyno !== '0') {
            this.selectedDocArticleKeyno = event.docarticle_keyno;
        }

        this.cdr.markForCheck();
    }

    public async createNewBook() {
        await this.remember.remember('docarticle_keyno_belongto', '0');
        this.selectedDocArticleKeyno = '0';
        this.cdr.markForCheck();
    }

    public async gotoCreateNewBook() {
        await this.remember.remember('docarticle_keyno_belongto', '0');
        this.state.go('docarticleedit', { docarticle_keyno: '0' });
    }

    private async loadRootDocArticles() {
        this.rootDocArticles = await this.docarticle.getDocarticleList(0);
    }

    private async loadDocArticlesTree() {
        this.docArticlesTree = await this.docarticle.getDocArticlesTree();
    }

    private async loadGet() {
        this.get = await this.docarticle.getDocArticle('0');
    }

    private async loadList() {
        if (this.tablet.matches) {
            await this.loadDocArticlesTree();
        } else {
            await this.loadRootDocArticles();
        }
    }

    private onMediaChange = async (_: Event) => {
        await this.loadList();
        this.cdr.markForCheck();
    };

    async ngOnInit(): Promise<void> {
        this.tablet.addEventListener('change', this.onMediaChange);
        await Promise.all([this.loadGet(), this.loadList()]);
        setTimeout(() => this.cdr.markForCheck());
    }

    ngOnDestroy(): void {
        this.tablet.removeEventListener('change', this.onMediaChange);
    }
}
